<script setup>

import { useStore } from 'vuex';
const store = useStore();

</script>

<template class="cmp-top-menu">
  <div id="Vue-3-component-top-menu" class="cmp-top-menu_wrapper">
    <div style="width: 100px;"></div>
    <div class="cmp-top-menu_menu-items">
      <div class="cmp-top-menu_no-options-menu-heading">
        <router-link v-if="store.state.mainMenu.dashboard.active" :to="{ name: 'dashboard'}">
          {{store.state.mainMenu.dashboard.alias}}</router-link>
<!--        <div v-else class="cmp-top-menu_heading-disabled-items" title="Feature Locked">-->
<!--        <i class="fa-solid fa-lock cmp-top-menu_list-icon" style="color: #e7b60c; font-size: 12px;">&#128274</i> Dashboard-->
<!--        </div>-->
      </div>
      <div v-if="store.state.mainMenu.orders.active" class="cmp-top-menu_menu-heading item-one">
        {{store.state.mainMenu.orders.alias}}
        <div class="cmp-top-menu_drop-menu show-items">
          <div class="cmp-top-menu_drop-menu-wrapper">
            <div class="cmp-top-menu_drop-menu-heading">
              <div v-for="(item, index) in store.state.mainMenu.orderItems" :key="index" class="cmp-top-menu_drop-menu-items">
                <router-link v-if="item.active" :to="{  name: item.view, params: { id: item.id ?? 0 }}">
                  &#128898{{ item.alias }}
                </router-link>
<!--                <div v-else class="cmp-top-menu_drop-menu-disabled-items" title="Feature Locked">-->
<!--                  <i class="fa-solid fa-lock cmp-top-menu_list-icon" style="color: #e7b60c;">&#128274</i> {{ item.alias }}-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="store.state.mainMenu.warehouse.active" class="cmp-top-menu_menu-heading item-one">
        {{store.state.mainMenu.warehouse.alias}}
        <div class="cmp-top-menu_drop-menu show-items">
          <div class="cmp-top-menu_drop-menu-wrapper">
            <div class="cmp-top-menu_drop-menu-heading">
              <div v-for="(item, index) in store.state.mainMenu.warehouseItems" :key="index" class="cmp-top-menu_drop-menu-items">
                <router-link v-if="item.active" :to="{ name: item.view,  params: { id: item.id?? 'new' }}">
                  &#128898 {{ item.alias }}
                </router-link>
<!--                <div v-else class="cmp-top-menu_drop-menu-disabled-items" title="Feature Locked">-->
<!--                  <i class="fa-solid fa-lock cmp-top-menu_list-icon" style="color: #e7b60c;"></i> {{ item.alias }}-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="store.state.mainMenu.quotes.active" class="cmp-top-menu_menu-heading item-one">
        {{store.state.mainMenu.quotes.alias}}
        <div class="cmp-top-menu_drop-menu show-items">
          <div class="cmp-top-menu_drop-menu-wrapper">
            <div class="cmp-top-menu_drop-menu-heading">
              <div v-for="(item, index) in store.state.mainMenu.quoteItems" :key="index" class="cmp-top-menu_drop-menu-items">
                <router-link v-if="item.active" :to="{  name: item.view, params: { id: item.id?? 'new' }}">
                  &#128898 {{ item.alias }}
                </router-link>
<!--                <div v-else class="cmp-top-menu_drop-menu-disabled-items" title="Feature Locked">-->
<!--                  <i class="fa-solid fa-lock cmp-top-menu_list-icon" style="color: #e7b60c;"></i> {{ item.alias }}-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="store.state.mainMenu.bookings.active" class="cmp-top-menu_menu-heading item-two">
        {{store.state.mainMenu.bookings.alias}}
        <div class="cmp-top-menu_drop-menu show-items">
          <div class="cmp-top-menu_drop-menu-wrapper">
            <div v-if="store.state.mainMenu.freightBooking.active" class="cmp-top-menu_drop-menu-heading"><span>Mode Free</span>
              <div v-for="(item, index) in store.state.mainMenu.freightItems" :key="index" class="cmp-top-menu_drop-menu-items">
                <router-link v-if="item.active" :to="{ name: item.view, params: { section: item.section, id: 'new' }}">
                  &#128898 {{ item.alias }}
                </router-link>
<!--                <div v-else class="cmp-top-menu_drop-menu-disabled-items" title="Feature Locked">-->
<!--                  <i class="fa-solid fa-lock cmp-top-menu_list-icon" style="color: #e7b60c;"></i> {{ item.alias }}-->
<!--                </div>-->
                <!--              <router-link v-if="item.active" to="/about">{{ item.text }}</router-link>-->
              </div>
            </div>
            <div class="menu-column">
              <div v-if="store.state.mainMenu.agentBooking.active" class="cmp-top-menu_drop-menu-heading"><span>Agent</span>
                <div v-for="(item, index) in store.state.mainMenu.agentItems" :key="index" class="cmp-top-menu_drop-menu-items">
                  <router-link v-if="item.active" :to="{  name: item.view, params: { section: item.section, id: 'new' }}">
                    &#128898 {{ item.alias }}
                  </router-link>
<!--                  <div v-else class="cmp-top-menu_drop-menu-disabled-items" title="Feature Locked">-->
<!--                    <i class="fa-solid fa-lock cmp-top-menu_list-icon" style="color: #e7b60c;"></i> {{ item.alias }}-->
<!--                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="store.state.mainMenu.shipments.active" class="cmp-top-menu_menu-heading item-one">
        {{store.state.mainMenu.shipments.alias}}
        <div class="cmp-top-menu_drop-menu show-items">
          <div class="cmp-top-menu_drop-menu-wrapper">
            <div class="cmp-top-menu_drop-menu-heading">
              <div v-for="(item, index) in store.state.mainMenu.shipmentItems" :key="index" class="cmp-top-menu_drop-menu-items">
                <router-link v-if="item.active" :to="{ name: item.view }">
                  &#128898 {{ item.alias }}
                </router-link>
<!--                <div v-else class="cmp-top-menu_drop-menu-disabled-items" title="Feature Locked">-->
<!--                  <i class="fa-solid fa-lock cmp-top-menu_list-icon" style="color: #e7b60c;"></i> {{ item.alias }}-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cmp-top-menu_no-options-menu-heading">
        <router-link v-if="store.state.mainMenu.documents.active" :to="{ name: 'documents' }">
          {{store.state.mainMenu.documents.alias}}</router-link>
<!--        <div v-else class="cmp-top-menu_heading-disabled-items" title="Feature Locked">-->
<!--          <i class="fa-solid fa-lock cmp-top-menu_list-icon" style="color: #e7b60c; font-size: 12px;"></i> Documents-->
<!--        </div>-->
      </div>
      <div class="cmp-top-menu_no-options-menu-heading">
        <router-link v-if="store.state.mainMenu.reports.active" :to="{ name: 'reports' }">
          {{store.state.mainMenu.reports.alias}}</router-link>
<!--        <div v-else class="cmp-top-menu_heading-disabled-items" title="Feature Locked">-->
<!--          <i class="fa-solid fa-lock cmp-top-menu_list-icon" style="color: #e7b60c; font-size: 12px;"></i> Reports-->
<!--        </div>-->
      </div>

<!--      End menu items flex area-->
    </div>
    <div class="welcome-user" style="width:220px;">
      &#128528;
<!--      <i class="fa-regular fa-user" style="padding-right: 10px; color: var(&#45;&#45;aqua-blue-definition);"></i>-->
      <span><strong>Welcome</strong></span>
      <span style="font-size: 12px; color: #131313; padding-left: 10px;">{{store.state.userSettings.firstName}}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.cmp-top-menu {

  &_item-icons {
    font-size: 16px;
    margin-right: 6px;
    color: #a2a2a2;
  }

  &_wrapper {
    display: flex;
    margin-top: 7px;
    justify-content: space-evenly;
    gap: 50px;
    user-select: none;
    background-image: var(--top-menu-bg);
    height:20px;
    color: var(--top-menu-text-color);
    font-size: 14px;
  }

  &_no-options-menu-heading {
    display: initial;
    width: max-content;
    //font-weight: bold;
  }

  &_menu-items {
    display: flex;
    gap: 30px;
    align-items: baseline;
  }

  &_menu-heading {
    position: relative;
    //cursor: pointer;
    font-size: 14px;
    height: 35px;
  }

  &_menu-heading:hover {
    font-weight: bold;
  }

  &_list-icon {
    color: #F68E1E;
  }

  &_no-options-menu-heading:hover {
    font-weight: bold;
    //border-bottom: 2px solid var(--aqua-blue-definition);
  }

  &_menu-heading::after {
    content: '';
    position: absolute;
    top: 6px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 9px solid  var(--left-border-highlight);
    opacity: 0;
    transition: 0.8s;
    height: 30px;
  }

  &_menu-heading:hover::after {
    opacity: 1;
  }

  &_drop-menu {
    z-index: 999999;
    position: absolute;
    visibility: hidden;
    top: 31px;
    display: flex;
    opacity: 0;
    padding: 5px 10px 10px 10px;
    background-color: #fff;
    border-bottom-left-radius: var(--rounded-corners);
    border-bottom-right-radius: var(--rounded-corners);
    transition: 0.2s;
    box-shadow: 1px 1px 2px 0 #888888;
  }

  &_drop-menu-wrapper {
    display: flex;
    gap: 10px;
  }

  &_drop-menu-heading {
    margin-top: 5px;
    font-size: 11px;
    font-weight: bold;
    cursor: default;
    color: #000;
  }

  &_drop-menu-heading span {
   margin-left: 4px;
  }

  &_drop-menu-disabled-items {
    font-weight: normal;
    font-size: 14px;
    opacity: 0.4;
    cursor: pointer;
    padding: 4px 4px 3px 4px;
    width: 150px;
  }

  &_heading-disabled-items {
    opacity: 0.4;
  }

  &_drop-menu-items a {
    font-weight: normal;
    font-size: 14px;
    opacity: 1;
    cursor: pointer;
    padding: 4px 4px 3px 4px;
    width: 150px;
  }

  &_drop-menu-items:hover a {
    background-color: var(--side-menu-color);
    color:var(--side-menu-text-color);
    border-radius: 4px;
    width: 150px;
  }

}

a {
  text-decoration: none !important;
  color: #161616;
  /*padding: 0px 0px 3px 2px;*/
  display: block;
}


/*on hover of the item classes, add the .show-items class to the drop menu to make is visible*/

.item-one:hover .show-items {
  visibility: visible;
  opacity: 1;
}

.item-two:hover .show-items {
  visibility: visible;
  opacity: 1;
}

@media screen and (max-width: 1225px) {
  .welcome-user {
    visibility: hidden;
  }

}

</style>
